import React from 'react';
import { useWeb3 } from '../contexts/Web3Context';
import { FARMING_POOLS } from '../utils/tokenConfig';
import { Sprout, TrendingUp } from 'lucide-react';
import { toast } from 'sonner';

const Farming = () => {
  const { account } = useWeb3();

  const handleFarm = (pool) => {
    if (!account) {
      toast.error('Please connect your wallet first');
      return;
    }
    toast.info(`Yield farming feature coming soon for ${pool.name}`);
  };

  return (
    <div data-testid="farming-page" className="min-h-screen py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">Yield Farming</h1>
          <p className="text-white/60 text-lg">Provide liquidity and earn enhanced rewards</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FARMING_POOLS.map((pool) => (
            <div
              key={pool.id}
              data-testid={`farming-pool-${pool.id}`}
              className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl p-6 hover:border-white/20 hover:bg-white/5 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 bg-primary/20 rounded-xl flex items-center justify-center">
                  <Sprout className="w-6 h-6 text-primary" />
                </div>
                <div className="flex items-center gap-1 bg-green-500/20 border border-green-500/30 px-3 py-1 rounded-full">
                  <TrendingUp className="w-3 h-3 text-green-500" />
                  <span className="text-xs font-mono text-green-500">{pool.apy}% APY</span>
                </div>
              </div>

              <h3 className="text-2xl font-semibold text-white mb-2">{pool.name}</h3>
              <p className="text-white/60 text-sm mb-4">Farm {pool.tokens.join('-')} LP tokens</p>

              <div className="space-y-3 mb-6">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-white/60">TVL</span>
                  <span className="text-sm font-mono text-white">${pool.tvl}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-white/60">Tokens</span>
                  <div className="flex items-center gap-1">
                    {pool.tokens.map(token => (
                      <span key={token} className="text-sm font-mono text-white bg-white/5 px-2 py-0.5 rounded">
                        {token}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-white/60">Your Position</span>
                  <span className="text-sm font-mono text-white">$0.00</span>
                </div>
              </div>

              <button
                onClick={() => handleFarm(pool)}
                data-testid={`farm-btn-${pool.id}`}
                className="w-full bg-primary hover:bg-primary/90 text-white font-medium py-3 rounded-full transition-all hover:scale-105 active:scale-95"
              >
                Start Farming
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
          <h2 className="text-2xl font-semibold text-white mb-6">Your Farming Summary</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <div className="text-sm text-white/60 mb-1">Total Value Locked</div>
              <div className="text-3xl font-mono font-bold text-white">$0.00</div>
            </div>
            <div>
              <div className="text-sm text-white/60 mb-1">Pending Rewards</div>
              <div className="text-3xl font-mono font-bold text-green-500">$0.00</div>
            </div>
            <div>
              <div className="text-sm text-white/60 mb-1">Average APY</div>
              <div className="text-3xl font-mono font-bold text-white">0.00%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Farming;